module.exports = __webpack_public_path__ + "media/customizations/regencyatbabcockranch/back-5e2e8c9cac17c2f82c4736ceee92586d.jpg";